import { createActions } from '@/utils/actions';

const { actions: studioPhotos } = createActions('studio.photos')
  .add('bootstrap')
  .add('cleanUp')
  .addAsync('createFolder')
  .addAsync('deleteFolder')
  .addAsync('deleteItems')
  .addAsync('downloadItems')
  .addAsync('getFolders')
  .addAsync('getItems')
  .addAsync('moveItems')
  .addAsync('renameFolder')
  .addAsync('saveItem')
  .addAsync('saveGeneratedVideo')
  .add('setValue')
  .add('toggleItemState')
  .addAsync('updateItem')
  .addAsync('uploadFiles');

export default studioPhotos;
